export default {
  pl: {
    failure: 'Awaria'
  },
  en: {
    failure: 'Failure'
  },
}
